import {Button, Card, FormLayout, Page, TextField,Toast} from '@shopify/polaris'
import React, {useState} from 'react'
import {useFormik} from 'formik';
import * as Yup from "yup";
import {ApiCall} from "../../helper/axios";
import {useSelector} from "react-redux";

function HomePageComponent() {
    const {status, store_data} = useSelector(
        (store) => store.commonData
    );
    const [saveActiveToast, setSaveActiveToast] = useState(false);
    const [saveBtnLoading, setSaveBtnLoading] = useState(false);
    const token = store_data?.token;

    const [initialState, setInitialState] = useState({
        email : '',
        phone : '',
        message : ''
    });

    const toggleActive = () => {
        setSaveActiveToast((saveActiveToast) => !saveActiveToast)
    };
    const handleSubmitFn = async () => {
        setSaveBtnLoading(true);
        let data = formik.values;
        try {
            const res = await ApiCall('POST', '/contact-support', data, { authentication: token });
            if (res?.data?.statusCode === 200) {
                formik.resetForm();
                setSaveActiveToast(true);
            } else {
                setSaveActiveToast(true);
            }
            setSaveBtnLoading(false);
        } catch (error) {
            setSaveActiveToast(true);
            setSaveBtnLoading(false);
        } finally {
            setSaveBtnLoading(false);
        }
    };

    const toastMarkup = saveActiveToast ? (
        <Toast content="We Will Answer Shortly." onDismiss={toggleActive} />
    ) : null;

    const formik = useFormik({
        initialValues: initialState,
        validationSchema: Yup.object({
            email: Yup.string().email('Please enter a valid email address').required('Email is required'),
            phone: Yup.string().required('Phone is required'),
            message: Yup.string().required('Message is required')
        }),
        enableReinitialize: true,
        onSubmit: () => {
            handleSubmitFn()
        }
    });

    return (
        <Page title="Contact Support">
            <Card>
                <FormLayout>
                    <FormLayout.Group>
                        <TextField
                            label="Email"
                            placeholder="Enter your email"
                            autoComplete="off"
                            value={formik.values.email}
                            onChange={(value) => { formik.setFieldValue('email', value) }}
                            onBlur={() => formik.setFieldTouched('email')}
                            error={formik.touched.email && formik.errors.email ? formik.errors.email : ''}
                        />
                    </FormLayout.Group>
                    <FormLayout.Group>
                        <TextField
                            label="Phone"
                            placeholder="Enter your Phone"
                            value={formik.values.phone}
                            onChange={(value) => { formik.setFieldValue('phone', value) }}
                            onBlur={() => formik.setFieldTouched('phone')}
                            error={formik.touched.phone && formik.errors.phone ? formik.errors.phone : ''}
                            autoComplete="off"
                        />
                    </FormLayout.Group>
                    <FormLayout.Group>
                        <TextField
                            label="Query"
                            multiline={4}
                            placeholder="write your query here"
                            value={formik.values.message}
                            onChange={(value) => { formik.setFieldValue('message', value) }}
                            onBlur={() => formik.setFieldTouched('message')}
                            error={formik.touched.message && formik.errors.message ? formik.errors.message : ''}
                            autoComplete="off"
                        />
                    </FormLayout.Group>
                </FormLayout>
                <div style={{ paddingTop: '20px', textAlign : 'end' }}>
                    <Button loading={saveBtnLoading} variant="primary" size="large" onClick={formik.handleSubmit}>
                        save
                    </Button>
                </div>
            </Card>
            {toastMarkup}
        </Page>
    )
}

export default HomePageComponent
